(() => {
  if (window.DRBOVideoHelpLayout) return;
  const layouts = new Map();

  const restore = (layout) => {
    for (const { node, marker } of layout.moves) {
      if (marker.isConnected) marker.replaceWith(node);
    }
    layout.summary.classList.remove('drbo-summary--video-help');
    layout.row.remove();
    layouts.delete(layout.template);
  };

  const initialize = () => {
    document.querySelectorAll('[data-drbo-video-help-template]').forEach((template) => {
      if (layouts.has(template)) return;
      const summary = document.getElementById(template.dataset.summaryId);
      const configurator = document.querySelector('[data-drbo-configurator]');
      const source = configurator?.closest('.shopify-section');
      const videos = source?.querySelector('[data-drbo-product-videos]');
      const expert = source?.querySelector('[data-drbo-product-module][data-module="expert"]');
      const destination = template.closest('.shopify-section');
      if (!summary || !videos || !expert || !destination || !videos.querySelector('[data-video-open]')) return;
      if (expert.closest('form')) return;
      const row = template.content.firstElementChild.cloneNode(true);
      const moves = [summary, videos, expert].map((node) => {
        const marker = document.createComment('drbo-video-help-origin');
        node.before(marker);
        return { node, marker };
      });
      expert.before(summary);
      row.querySelector('[data-video-help-videos]').appendChild(videos);
      row.querySelector('[data-video-help-expert]').appendChild(expert);
      destination.appendChild(row);
      summary.classList.add('drbo-summary--video-help');
      layouts.set(template, { template, summary, source, destination, row, moves });
      window.dispatchEvent(new Event('resize'));
    });
  };

  window.DRBOVideoHelpLayout = { initialize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:unload', (event) => {
    for (const layout of layouts.values()) {
      if (event.target === layout.source || event.target === layout.destination) restore(layout);
    }
  });
  document.addEventListener('shopify:section:load', initialize);
})();
